var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParaguay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb2e40",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1334a3",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M18.28 12a3.28 3.28 0 1 1-6.56 0 3.28 3.28 0 0 1 6.56 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.84 12a2.84 2.84 0 1 1-5.68 0 2.84 2.84 0 0 1 5.68 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M17.74 12a2.73 2.73 0 1 1-5.47 0 2.73 2.73 0 0 1 5.47 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#99aab5",
    d: "M17.74 11.98a2.74 2.74 0 1 0-5.11 1.38l2.37-1.3 2.37 1.3q.36-.62.37-1.38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.19 12a2.19 2.19 0 1 1-4.38 0 2.19 2.19 0 0 1 4.38 0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M15 14.1a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffac33",
    d: "m15 11.28.16.5h.52l-.42.3.16.5-.42-.3-.42.3.16-.5-.42-.3h.52z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#007127",
    d: "M15.43 10.7s.27-.06.42-.07c.16-.02.3.33.48.4.19.06.18.24.26.46s.03.26.03.5c0 .25.14.38.1.56-.02.19-.18.23-.27.36s-.01.27-.1.37-.4.07-.51.17c-.11.09-.31.23-.45.15s-.43-.1-.43-.1.07-.28.29-.38.3-.07.5-.14c.2-.06.2-.15.33-.27.14-.13.16-.3.23-.42s.1-.22.07-.39a2 2 0 0 0-.45-.96c-.1-.1-.5-.24-.5-.24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#007127",
    d: "M14.48 10.8s.15-.34 0-.36c-.62-.08-.74.48-.93.54-.18.06-.21.37-.29.58-.07.22-.04.27-.04.51 0 .25 0 .3.03.48q.03.27.17.45c.09.12.12.18.22.27.09.1.27.19.38.28s.43.13.57.05.38-.1.38-.1-.1-.2-.32-.29c-.21-.09-.23-.17-.43-.23s-.18-.15-.32-.27-.15-.3-.23-.42-.04-.16 0-.32q.04-.24.15-.47c.06-.15.21-.35.3-.46.1-.1.36-.25.36-.25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#007127",
    d: "m14.5 13.63.2.14.26-.19.24.17.33-.12-.33.23-.23-.18-.24.17-.25-.14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaguay);
export default __webpack_public_path__ + "static/media/paraguay.1a0fb1ee684881cc8387451c48376996.svg";
export { ForwardRef as ReactComponent };